import { render, staticRenderFns } from "./RadioTextInput.vue?vue&type=template&id=48e1fcd0&scoped=true&"
import script from "./RadioTextInput.vue?vue&type=script&lang=js&"
export * from "./RadioTextInput.vue?vue&type=script&lang=js&"
import style0 from "./RadioTextInput.vue?vue&type=style&index=0&id=48e1fcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e1fcd0",
  null
  
)

export default component.exports